import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { CommonService } from './service/commons-service';
import { MailService } from './service/mail.service';
import { AppConfig, Common } from './util';
import { AppComponent } from './app.component';
import { LoginComponent } from './login';
import { HeaderCustomComponent } from './header/headerCustom.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {NgbModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal'; 
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddResourceComponent } from './addResource/addResource.component';
import { SidebarWrapperComponent } from './sidebarWrapper/sidebarWrapper.component';
import { InterventionComponent } from './resourceIntervention/intervention.component';
import { ScoreComputationComponent } from './scoreComputation/scoreComputation.component';
import { SkillRatingSectionComponent } from './skillRatingSection/skillRatingSection.component';
import { SelfRatingSectionComponent } from './selfRatingSection/selfRatingSection.component';
import { ManagerRatingSectionComponent } from './managerRatingSection/managerRatingSection.component';
import { AdminDashboardComponent } from './adminDashboard/adminDashboard.component';
import { IBUComponent } from './ibu/ibu.component';
import { AdminSidebarComponent } from './admin-sidebar/admin-sidebar.component';
import { TowerComponent } from './tower/tower.component';
import { ManagementUsersComponent } from './managementUser/managementusers.component';
import { AdminUserComponent } from './superAdminUser/adminuser.component';
import { FunctionalSkillMasterComponent } from './functionalSkillMaster/functionalSkillMaster.component';
import { BehavioralSkillMasterComponent } from './behavioralSkillMaster';
import { SkillRatingMasterComponent } from './skillRatingMaster/skillRatingMaster.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { PositionLadderComponent } from './position-ladder/position-ladder.component';
import { TrainingComponent } from './training/training.component';
import { NominateComponent } from './nominate/nominate.component';
import { InterestedUsersComponent } from './interested-users/interested-users.component';
import { RatingHistoryComponent } from './rating-history/rating-history.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CompetencyReportComponent } from './competency-report/competency-report.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';

const materialModules = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  MatTabsModule,
  MatExpansionModule
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    HeaderCustomComponent,
    AddResourceComponent,
    SidebarWrapperComponent,
    InterventionComponent,
    ScoreComputationComponent,
    SkillRatingSectionComponent,
    SelfRatingSectionComponent,
    ManagerRatingSectionComponent,
    AdminDashboardComponent,
    IBUComponent,
    AdminSidebarComponent,
    TowerComponent,
    ManagementUsersComponent,
    AdminUserComponent,
    FunctionalSkillMasterComponent,
    BehavioralSkillMasterComponent,
    SkillRatingMasterComponent,
    UserDashboardComponent,
    PositionLadderComponent,
    TrainingComponent,
    NominateComponent,
    InterestedUsersComponent,
    RatingHistoryComponent,
    BreadcrumbComponent,
    CompetencyReportComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    NgbAlertModule,
    ModalModule.forRoot(), 
    BrowserAnimationsModule,
    DataTablesModule,
    ...materialModules,
    NgMultiSelectDropDownModule.forRoot()
  ],
  exports: [
    ...materialModules
  ],
  providers: [
    DatePipe,
    MailService,
    AppConfig,
    CommonService,
    Common,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
